module.exports = __webpack_public_path__ + "static/media/arrow.fa525153.svg";